import styled from 'styled-components';

export const InputTextArea = styled.textarea`
box-sizing: border-box;
border: 1px solid #F0F0F0;
border-radius: 8px;
background-color: #FFFFFF;
box-shadow: 0 12px 18px 0 rgba(0,0,0,0.02);
margin:0px 18px 0px 0px;
display:flex;
flex-direction:column;
justify-content:flex-end;
width:100%;
resize: none;
`;



